import {SectionBgView} from '../../ui_canvas_engine/SectionBgView'
import {GameEndTabButtonView} from '../../ui_canvas_engine/GameEndTabButtonView'
import {CA} from '../../analytics/Analytics'
import {UIGameEndStatsController} from './UIGameEndStatsController'
import {GameModeTranslationKeyContext} from '@colonist/i18n'

export class UIGameEndTabButtonsView extends SectionBgView {
    overView: GameEndTabButtonView
    diceStats: GameEndTabButtonView
    resourceCardStats: GameEndTabButtonView
    developmentCardStats: GameEndTabButtonView
    activityStats: GameEndTabButtonView
    resourceStats: GameEndTabButtonView

    private readonly tabWidth: number
    private readonly tabHeight: number
    private numberOfTabsCreated: number

    private readonly statsController: UIGameEndStatsController
    private readonly gameModeTranslationKeyContext: GameModeTranslationKeyContext

    constructor(x: number, y: number, w: number, h: number, numberOfTabs: number, container: SectionBgView, statsController: UIGameEndStatsController, gameModeTranslationKeyContext: GameModeTranslationKeyContext) {
        super(x, y, w, h, container)
        this.statsController = statsController
        this.tabWidth = this.width / numberOfTabs
        this.tabHeight = this.height
        this.numberOfTabsCreated = 0
        this.gameModeTranslationKeyContext = gameModeTranslationKeyContext
    }

    createOverviewTab() {
        this.overView = new GameEndTabButtonView(this.tabWidth * this.numberOfTabsCreated, 0, this.tabWidth, this.tabHeight, this)
        this.overView.updateText({key: 'strings:game.endGame.overview.title'})
        this.overView.updateAction(() => {
            this.statsController.clickedTab(this.overView)
            CA.sendGoogleAnalyticsEvent(CA.Category.EndGame, CA.Label.ClickedEndGameOverview)
        })
        this.numberOfTabsCreated += 1
    }

    createDiceStatsTab() {
        this.diceStats = new GameEndTabButtonView(this.tabWidth * this.numberOfTabsCreated, 0, this.tabWidth, this.tabHeight, this)
        this.diceStats.updateText({key: 'strings:game.endGame.dice.title'})
        this.diceStats.updateAction(() => {
            this.statsController.clickedTab(this.diceStats)
            CA.sendGoogleAnalyticsEvent(CA.Category.EndGame, CA.Label.ClickedEndGameDiceStats)
        })
        this.numberOfTabsCreated += 1
    }

    createResourceCardStatsTab() {
        this.resourceCardStats = new GameEndTabButtonView(this.tabWidth * this.numberOfTabsCreated, 0, this.tabWidth, this.tabHeight, this)
        this.resourceCardStats.updateText({key: 'strings:game.endGame.resourceCards.title'})
        this.resourceCardStats.updateAction(() => {
            this.statsController.clickedTab(this.resourceCardStats)
            CA.sendGoogleAnalyticsEvent(CA.Category.EndGame, CA.Label.ClickedEndGameResourceCardStats)
        })
        this.numberOfTabsCreated += 1
    }

    createDevCardStatsTab() {
        this.developmentCardStats = new GameEndTabButtonView(this.tabWidth * this.numberOfTabsCreated, 0, this.tabWidth, this.tabHeight, this)
        this.developmentCardStats.updateText({
            key: 'strings:game.endGame.devCards.title',
            options: {
                context: this.gameModeTranslationKeyContext,
            },
        })
        this.developmentCardStats.updateAction(() => {
            this.statsController.clickedTab(this.developmentCardStats)
            CA.sendGoogleAnalyticsEvent(CA.Category.EndGame, CA.Label.ClickedEndGameDevelopmentCardStats)
        })
        this.numberOfTabsCreated += 1
    }

    createActivityStatsTab() {
        this.activityStats = new GameEndTabButtonView(this.tabWidth * this.numberOfTabsCreated, 0, this.tabWidth, this.tabHeight, this)
        this.activityStats.updateText({key: 'strings:game.endGame.activity.title'})
        this.activityStats.updateAction(() => {
            this.statsController.clickedTab(this.activityStats)
            CA.sendGoogleAnalyticsEvent(CA.Category.EndGame, CA.Label.ClickedEndGameActivityStats)
        })
        this.numberOfTabsCreated += 1
    }

    createResourceStatsTab() {
        this.resourceStats = new GameEndTabButtonView(this.tabWidth * this.numberOfTabsCreated, 0, this.tabWidth, this.tabHeight, this)
        this.resourceStats.updateText({key: 'strings:game.endGame.resource.title'})
        this.resourceStats.updateAction(() => {
            this.statsController.clickedTab(this.resourceStats)
            CA.sendGoogleAnalyticsEvent(CA.Category.EndGame, CA.Label.ClickedEndGameResourceStats)
        })
        this.numberOfTabsCreated += 1
    }
}
